import PropTypes from 'prop-types';

const clinician = PropTypes.shape({
  clinicianFullName: PropTypes.string.isRequired,
  clinicianColor: PropTypes.string.isRequired,
  id: PropTypes.number,
  dateOfBirth: PropTypes.string,
  forename: PropTypes.string,
  knownAs: PropTypes.string,
  maidenName: PropTypes.string,
  middleInitials: PropTypes.string,
  staffNumber: PropTypes.string.isRequired,
  surname: PropTypes.string.isRequired,
});

export default clinician;
